// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__39t-o","inputWrap":"CustomTip_inputWrap__278LQ"};